import { Button, Flex, TextInput } from "@mantine/core";
import { isNotEmpty, useForm } from "@mantine/form";
import { useCallback } from "react";

import { useUpdateMe } from "../../api/hooks/user/useUpdateMe.ts";
import Preloader from "../../components/Preloader/Preloader.tsx";
import SectionTitle from "../../components/Section/SectionTitle/SectionTitle.tsx";
import { useMutationNotificationWrapper } from "../../hooks/useMutationNotificationWrapper.tsx";
import { useCurrentUserContext } from "../../providers/CurrentUserProvider.tsx";

export const ProfileSettingForm = () => {
  const { user, fetching, refresh } = useCurrentUserContext();

  const [{ fetching: isSaving }, updateMe] = useMutationNotificationWrapper(
    useUpdateMe(),
    {
      success: { message: "Name has been successfully updated." },
    }
  );

  const form = useForm({
    initialValues: {
      name: user?.name ?? "",
    },
    validate: {
      name: isNotEmpty("Field is required"),
    },
    validateInputOnBlur: true,
  });

  const handleSubmit = useCallback(() => {
    if (!form.isValid()) {
      return;
    }
    updateMe({ input: form.values }).then(refresh);
  }, [form, refresh, updateMe]);

  if (fetching) {
    return <Preloader loading={true} />;
  }

  return (
    <>
      <Flex direction="column" gap={12} w="35%">
        <SectionTitle flex={0} isSmall variant="golden">
          Profile Settings
        </SectionTitle>
        <TextInput
          required
          disabled={isSaving}
          label="Name"
          placeholder="Name"
          size="m"
          type="text"
          {...form.getInputProps("name")}
        />
        <Flex justify="flex-end">
          <Button
            variant="outlineBlue"
            size="m"
            type="submit"
            uppercase
            w="50%"
            disabled={!form.isValid()}
            loading={isSaving}
            onClick={handleSubmit}
          >
            save
          </Button>
        </Flex>
      </Flex>
    </>
  );
};
